const TIMEZONE_SUFFIX_RE = /Z|[+-]\d{2}:?\d{2}$/;

export function parseUtcDate(value: string | Date | null | undefined): Date {
  if (!value) return new Date(NaN);
  if (value instanceof Date) return value;

  const hasTimezone = TIMEZONE_SUFFIX_RE.test(value);
  return new Date(hasTimezone ? value : value + 'Z');
}
